import { Statistics } from 'shared/model/statistic.model';
import Metric from 'shared/routes/components/Metric/Metric';

type Props = {
  stats?: Statistics;
};

const ConnectionMetric = ({ stats }: Props) => {
  let nb = 0;
  if (stats) {
    nb = stats.usersConnections.reduce((acc, c) => acc + c.connectionNb, 0);
  }

  return <Metric label="Number of connections">{nb}</Metric>;
};

export default ConnectionMetric;
